import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {onMounted} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {Routes} from "@/router/routes";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

let store = useStore();
let router = useRouter();

onMounted(() => {
  store.commit("authenticate", localStorage.getItem("token"))
  
  if (!localStorage.getItem("token")) {
    router.push(Routes.LOGIN)
  }

});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})